import { appLogConstants } from '../constants';

const initialState = {
  items: [],
  total: 0,
  loading: false,
  levels: [],
  detail: null,
  detailLoading: false,
  error: null,
};

export function appLogs(state = initialState, action) {
  switch (action.type) {
    case appLogConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case appLogConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false,
      };
    case appLogConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case appLogConstants.LEVELS_SUCCESS:
      return {
        ...state,
        levels: action.levels,
      };
    case appLogConstants.SHOW_REQUEST:
      return {
        ...state,
        detailLoading: true,
        detail: null,
      };
    case appLogConstants.SHOW_SUCCESS:
      return {
        ...state,
        detail: action.detail,
        detailLoading: false,
      };
    case appLogConstants.SHOW_FAILURE:
      return {
        ...state,
        detailLoading: false,
        error: action.error,
      };
    case appLogConstants.SHOW_CLEAR:
      return {
        ...state,
        detail: null,
        detailLoading: false,
      };
    default:
      return state;
  }
}
